import { getTimestamp } from './draftGetters';
export const hasDraftExpired = (draft, ageLimitInMs) => {
  const timestamp = getTimestamp(draft);
  const expired = timestamp < Date.now() - ageLimitInMs;
  return expired;
};